import { render, staticRenderFns } from "./ComparisonBarChart.vue?vue&type=template&id=a6856ba8&scoped=true"
import script from "./ComparisonBarChart.vue?vue&type=script&lang=js"
export * from "./ComparisonBarChart.vue?vue&type=script&lang=js"
import style0 from "./ComparisonBarChart.vue?vue&type=style&index=0&id=a6856ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6856ba8",
  null
  
)

export default component.exports